import { render } from "./PaymentGetWay.vue?vue&type=template&id=1e283524"
import script from "./PaymentGetWay.vue?vue&type=script&lang=js"
export * from "./PaymentGetWay.vue?vue&type=script&lang=js"

import exportComponent from "/workspace/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__